import React from "react";
import { Container } from "react-bootstrap";
import { AiOutlineMail } from "react-icons/ai";
import { profile, certifications, skillGroups, experience } from "./resumeData";
import ResumeExperience from "./ResumeExperience";
import "./Resume.css";

function Resume() {
  return (
    <Container fluid className="resume-section">
      <Container className="resume-container">
        <header className="resume-header">
          <h1 className="resume-name">{profile.name}</h1>
          <p className="resume-title">{profile.title}</p>
          <p className="resume-summary">{profile.summary}</p>
          <div className="resume-contact-row">
            <a href={`mailto:${profile.email}`} className="resume-contact-item">
              <AiOutlineMail /> {profile.email}
            </a>
          </div>
        </header>

        <section className="resume-block">
          <div className="resume-block-header">
            <h2 className="resume-block-title">Certifications</h2>
            <span className="resume-block-count">{certifications.length} credentials</span>
          </div>
          <div className="resume-cert-grid">
            {certifications.map((cert) => (
              <div className="resume-card" key={cert.name}>
                <div className="resume-card-top-row">
                  <p className="resume-cert-name">{cert.name}</p>
                  <span className="resume-dot resume-dot-active" />
                </div>
                <p className="resume-cert-meta">
                  {cert.issuer} · {cert.year}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="resume-block">
          <div className="resume-block-header">
            <h2 className="resume-block-title">Skills</h2>
            <span className="resume-block-count">{skillGroups.length} categories</span>
          </div>
          <div className="resume-skill-groups">
            {skillGroups.map((group) => (
              <div className="resume-skill-group" key={group.title}>
                <p className="resume-skill-group-title">{group.title}</p>
                <div className="resume-chip-row">
                  {group.skills.map((skill) => (
                    <span className="resume-chip" key={skill}>
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="resume-block">
          <div className="resume-block-header">
            <h2 className="resume-block-title">Experience</h2>
            <span className="resume-block-count">{experience.length} roles</span>
          </div>
          <ResumeExperience />
        </section>
      </Container>
    </Container>
  );
}

export default Resume;
